import { Component, Input } from '@angular/core';
import { ChipModule } from 'primeng/chip';

import { EventTicketDetailed } from '../../../../data-services/models/event-tickets/event-ticket-detailed.model';
import { CommonModule } from '@angular/common';
import { EventTicketBasic } from '../../../../data-services/models/event-tickets/event-ticket-basic.model';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTicket, faUtensils, faStopwatch, faSpaghettiMonsterFlying, faBed } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-ticket-pill',
  imports: [ChipModule,CommonModule,FontAwesomeModule],
  templateUrl: '../ui/ticket-pill.component.html',
  styleUrl: '../ui/ticket-pill.component.css'
})
export class TicketPillComponent {
  @Input() primaryTicket?: EventTicketDetailed | EventTicketBasic;
  @Input() additionalTickets?: EventTicketDetailed[] | EventTicketBasic[];
  @Input() columnView: boolean = true;
  @Input() includePrice: boolean = false;

  constructor(private readonly _iconLib: FaIconLibrary) {
    this._iconLib.addIcons(faTicket, faUtensils, faStopwatch, faSpaghettiMonsterFlying, faBed);
  }
}
